import http from "../util/http";

const modules = `sy`;

const modulesCt = "ct";

export default {

  getXiLongStock: data => http.get(`${modules}/setting/getXiLongStock`, data), // 首页股票涨幅接口
  broadcastList: data => http.get(`${modulesCt}/broadcast/list`, data), // 首页轮播图
  articleList: data => http.get(`at/article/list`, data), // 文章
};